/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react';

const TABS_MAPPING = {
  0: 'overview',
  1: 'squad',
  2: 'news',
  3: 'crs',
};

function Tabs({ switchContent }) {
  const [selectedTab, setSelectedTab] = useState(0);

  const onPress = (tab) => {
    if (selectedTab !== tab) {
      setSelectedTab(tab);
      switchContent(TABS_MAPPING[tab]);
    }
  };

  return (
    <div className="tabs-container site-container--hug-on-mobile">
      <ul className="section-tabs section-tabs--team">
        <li
          onClick={() => onPress(0)}
          className={`section-tabs__item ${
            selectedTab === 0 ? 'section-tabs__item--active' : ''
          }`}
        >
          Översikt
        </li>
        <li
          onClick={() => onPress(1)}
          className={`section-tabs__item ${
            selectedTab === 1 ? 'section-tabs__item--active' : ''
          }`}
        >
          Truppen
        </li>
        <li
          onClick={() => onPress(2)}
          className={`section-tabs__item ${
            selectedTab === 2 ? 'section-tabs__item--active' : ''
          }`}
        >
          Nyheter
        </li>
      </ul>
    </div>
  );
}

export default Tabs;
